export default function replaceUrlParam(
  url: string,
  paramName: string,
  paramValue: string | null | undefined
): string {
  // Use a dummy base to force the URL parser to accept relative paths
  const dummyBase = 'https://dummy.test';
  const urlObj = new URL(url, dummyBase);
  const isRelative = urlObj.origin === dummyBase;
  urlObj.searchParams.set(paramName, paramValue ?? '');
  const newUrl = urlObj.toString();
  return isRelative ? newUrl.replace(dummyBase, '') : newUrl;
}
